import $ from 'jquery';
import { defaultOptions } from '../../tippy-util.js';
import { closeAllExceptThis, menuTippyInstances } from '../../menu-objects/shared-objects.js';
import { applyComponentClickRestrictions } from '../../../../util/dom.js';
import { loadPartial } from '../../../../remote/partial-content.js';

export const COMPONENT_CONTENT_SELECTOR = '.ajax-content';

/**
 * @param {JQuery} $container
 * @param {HTMLElement} trigger
 * @param {Partial<import('tippy.js').Props>} options
 */
export default async ($container, trigger, options) => {

	// Standard component click restrictions
	if (applyComponentClickRestrictions('dropdown', options) === false) {
		// @ts-ignore Not all code paths return a value.ts(7030)
		return;
	}

	const $trigger = $(trigger);

	// Make sure attrs with href are not executed
	// ? Also, very important that we remove the event handler for redirecting to the cart page so we don't trigger both actions at the same time
	$trigger.off('click.show-cart-page').on('click.show-cart-popup', (e) => {
		e.preventDefault();
	});

	// Import the tippy lib lazily
	const { 'default': tippy } = await import('tippy.js');

	// @ts-ignore
	const instance = tippy(trigger, {

		// Merge with default config
		...defaultOptions,

		role: 'menu',
		appendTo: $container[0],
		content: mpro.getLoadingPlaceholder(),
		placement: 'bottom-end',
		popperOptions: {
			modifiers: [
				...defaultOptions.popperOptions.modifiers,
				{
					name: 'dropdown',
					enabled: true,
					phase: 'beforeWrite',
					fn: (data) => {
						const $tippyBox = $(data.state.elements.popper).find('.tippy-box');
						const $tippyContent = $(data.state.elements.popper).find('.tippy-content');
						const $popoverContainer = $(data.state.elements.popper).find('[data-popover-container]');
						const isLoading = $(data.state.elements.popper).find('.loading').length > 0;
						$tippyBox.css({
							'width': window.matchMedia('(min-width: 564px)').matches ? '600px' : '100vw',
							'min-height': '250px',
							'display': 'flex',
							'justify-content': 'center',
							'align-items': isLoading ? 'center' : 'stretch',
						});
						$tippyContent.css({
							'width': '100%',
						});
						$popoverContainer.css({
							'height': '100%',
						});
					},
				},
			],
		},
		trigger: 'click',
		onTrigger: closeAllExceptThis,
		onShown: async (instance) => {

			/* Set content from cart_preview */
			try {

				const $container = $(instance.popper).find('div.tippy-content');

				await _loadRemoteContent($trigger, $container);

				$container.on('mp-section-reload', async (e) => {
					e.stopPropagation();
					e.stopImmediatePropagation();

					await _loadRemoteContent($trigger, $container);
				});
			}
			catch {
				// console.error(e);
			}

			// Disable scrolling on the body
			mpro.preventScroll();
		},
		onHide: () => {
			// Restore scrolling on the body
			mpro.allowScroll();
		},
		onHidden(instance) {
			instance.setContent(mpro.getLoadingPlaceholder());
		},
	});

	const triggerData = $trigger.data() || {};
	triggerData.instance = instance;
	triggerData._abortController = {};
	$trigger.data(triggerData);

	// Add to tippy menu instances list to simulate singleton
	menuTippyInstances.add(instance);

	return instance;
};

/**
 * @param {JQuery} $trigger
 * @param {JQuery} $container
 * @param {import('../../../../remote/partial-content').LoadPartialOptions=} loadPartialOptions
 */
const _loadRemoteContent = async ($trigger, $container, loadPartialOptions = {}, customOpt = {}) => {

	const { instance, _abortController } = $trigger.data();
	let partial;

	// Abort previous request
	if (_abortController.abort) {
		_abortController.abort();
	}

	try {
		// Reload partial content from remote source
		partial = await loadPartial($container, {
			url: mpro.config.routes.cart_preview_dropdown,
			...loadPartialOptions,
			type: 'fragment',
			contentSelector: COMPONENT_CONTENT_SELECTOR,
			// emptyContainer: true, // This is a port from flex, but it might not be needed
			animation: true,
			ref: _abortController,
			allowDetached: true,
		});

		// Update the popper instance
		instance.popperInstance.update();

		return partial;
	}
	finally {
		// Clear the abort ref (instance might already be destroyed)
		if (_abortController) {
			$trigger.data('_abortController', {});
		}
	}
};
